import Model from './Model';
import { observable } from 'mobx';


class GlossaryEntry extends Model {
  static basePath = '/api/glossary-entries';
  static verboseName = 'GlossaryEntry';

  @observable category;
  @observable name;
  @observable definition;
}


export default GlossaryEntry;
